import React, { Component } from "react";
import { Row, Col, Card, Table} from "reactstrap";
import CgnAlert from "../toolbox/CgnAlert";
import CgnLoader from "../toolbox/CgnLoader";
import CgnButtonLink from "../toolbox/CgnButtonLink";
import ContentTop from "../root/ContentTop";
import axios from "axios";
import { URL } from "../../redux/actions/constants";

class LocationDeliveryDetail extends Component {
  state = {
    pageTitle: "Depo Ürün İşlem Detay",
    pageTitleDetail: "Depo Ürün İşlem Detay",
    pageAddLink: "depo-urun-islemi-ekle",
    pageListLink: "depo-urun-islemi-listele",
    breadcrumb: [{ text: "Depo Ürün İşlem", link: "#" }],
    isLoading: false,
    alertErrorMessage: "",
    image: "",
    workDate: "",
    workStartDate: "",
    workEndDate: "",
    entryType: "",
    entryDate: "",
    entryHour: "",
    workInstructionDate: "",
    WorkInstructionCode: "",
    locationName: "",
    customerName: "",
    personelName: "",
    productOutName: "",
    productCode: "",
    productName: "",
    piece: "",
    locationDeliveryProductDto: [],
    workOrderStepName: "",
    productOutTotal: "",
    productOutDate: "",
    productOutCustomer: "",
    code: "",
    name: "",
    status: "",
    createdBy: "",
    createdAt: "",
    updatedAt: "",
    updatedBy: "",
    decsription: "",
    currencyType: "",
  };

  async componentDidMount() {
    let urlSplit = window.location.pathname.split("/");
    if (urlSplit.length === 3) {
      this.setState({
        pageTitle: this.state.pageTitleDetail,
        isLoading: true,
      });
      // 
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      axios
        .get(URL + "/locationDeliveries/get/" + urlSplit[2], config)
        .then((response) => {
          this.setState({
            workInstructionCode: response.data.workInstructionCode,
            workInstructionDate: response.data.workInstructionDate,
            entryType: response.data.entryType,
            entryDate: response.data.entryDate,
            entryHour: response.data.entryHour,
            locationName: response.data.locationName,
            customerName: response.data.customerName,
            personelName: response.data.personelName,
            decsription: response.data.decsription,
            workStartDate: response.data.workStartDate,
            workEndDate: response.data.workEndDate,
            productOutDate: response.data.productOutDate,
            productOutTotal: response.data.productOutTotal,
            productOutCustomer: response.data.productOutCustomer,
            createdBy: response.data.createdBy,
            createdAt: response.data.createdAt,
            updatedBy: response.data.updatedBy,
            updatedAt: response.data.updatedAt,
            isLoading: false,
            currencyType: response.data.currencyType,
            locationDeliveryProductDto: response.data.locationDeliveryProductDto,
          });
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoading: false,
          });
        });
    }
  }

  toggle = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  };
  

  render() {
    const mainRow = {
      backgroundColor: "#9B9796",
      color: "#fff",
    };
    const subRow = {
      backgroundColor: "#f2f2f2",
    };
    var self = this.state;
    return (
      <>
        <ContentTop
          breadcrumb={this.state.breadcrumb}
          title={this.state.pageTitle}
          addLink={"/" + this.state.pageAddLink}
          listLink={"/" + this.state.pageListLink}
        />
        <Row>
          <Col>
            <Card body className="table-responsive">
              <CgnLoader visibled={this.state.isLoading} />
              {this.state.alertErrorMessage && (
                <CgnAlert
                  color="danger"
                  title="Uyarı"
                  text={this.state.alertErrorMessage}
                />
              )}
              <Table className="table table-responsive table-hover">
                <tbody>
                  <tr>
                    <th>Tipi</th>
                    <td colSpan="4">
                      {this.state.entryType === 1 ? "Giriş" : this.state.entryType === 2 ? "Teslim" : this.state.entryType === 3 ? "İade" : "-"}
                    </td>
                  </tr>                 
                  
                  <tr style={{display: this.state.entryType === 1 || this.state.entryType === 2 ? "" : "none"}}>
                    <th>Teslim Tarihi</th>
                    <td colSpan="4">
                      {this.state.entryDate}
                    </td>
                  </tr>
                  <tr style={{display: this.state.entryType === 1 || this.state.entryType === 2 ? "" : "none"}}>
                    <th>Teslim Saati</th>
                    <td colSpan="4">
                      {this.state.entryHour}
                    </td>
                  </tr>

                  <tr style={{display: this.state.entryType === 3 ? "" : "none"}}>
                    <th>İade Tarihi</th>
                    <td colSpan="4">
                      {this.state.entryDate}
                    </td>
                  </tr>
                  <tr style={{display: this.state.entryType === 3 ? "" : "none"}}>
                    <th>İade Saati</th>
                    <td colSpan="4">
                      {this.state.entryHour}
                    </td>
                  </tr>

                  <tr>
                    <th>İş Emri No</th>
                    <td>
                      {this.state.workInstructionCode}
                    </td>

                    <th>İş Emri Tarihi</th>
                    <td>
                      {this.state.workInstructionDate}
                    </td>
                  </tr>

                  <tr>
                    <th>Müşteri</th>
                    <td colSpan="4">
                      {this.state.customerName}
                    </td>
                  </tr>

                  <tr>
                    <th>Personel</th>
                    <td colSpan="4">
                      {this.state.personelName}
                    </td>
                  </tr>

                  <tr>
                    <th>Başlangıç Tarihi</th>
                    <td>
                      {this.state.workStartDate}
                    </td>
                    <th>Bitiş Tarihi</th>
                    <td>
                      {this.state.workEndDate === "01/01/1900" ? "-" : this.state.workEndDate}
                    </td>
                  </tr>

                  <tr>
                    <th>Satış</th>
                    <td colSpan="4">
                      {this.state.productOutDate + "-" + this.state.productOutCustomer}
                    </td>
                  </tr>
              
                  <tr>
                    <th>Kaydeden Kullanıcı</th>
                    <td>{this.state.createdBy ? this.state.createdBy : "-"}</td>
                    <th>Kaydedilme Tarihi</th>
                    <td>{this.state.createdAt ? this.state.createdAt : "-"}</td>
                  </tr>
                  <tr>
                    <th>Son Güncelleyen Kullanıcı</th>
                    <td>{this.state.updatedBy ? this.state.updatedBy : "-"}</td>
                    <th>Son Güncellenme Tarihi</th>
                    <td>{this.state.updatedAt ? this.state.updatedAt : "-"}</td>
                  </tr>
                </tbody>
              </Table>

              {this.state.locationDeliveryProductDto !== null &&
                this.state.locationDeliveryProductDto.length > 0 && (
                  <>
              <div
                className="row"
                style={{
                  display:
                    self.locationDeliveryProductDto !== null && self.locationDeliveryProductDto.length > 0
                      ? ""
                      : "none",
                }}
              >
                <h2 className="mt-2">Ürünler</h2>
              </div>
              <Table className="table table-responsive table-hover table-product2">
                    <tr style={mainRow}>
                      <th>Ürün</th>
                      <th className="text-center">Ürün Adedi</th>                   
                      <th>Teslim/İade Adedi</th>
                      <th>Stok Adedi</th>
                    </tr>
                    {this.state.locationDeliveryProductDto.map(function (item) {
                      return (
                        <tr style={subRow}>
                          <td>{item.productCode + "-" + item.productName}</td>
                          <td className="text-center">{item.piece}</td>
                          <td>{item.deliveryPiece}</td>
                          <td>{item.stockPiece}</td>
                        </tr>
                      );
                    })}
                  </Table>
                  </>
                )}              
            </Card>
            <CgnButtonLink
              color="secondary"
              to={"/" + this.state.pageListLink}
              text="Geri"
              className="btn-back"
            />
          </Col>
        </Row>
      </>
    );
  }
}

export default LocationDeliveryDetail;
